const headerData = [{
		types: "selection",
		columnwidth: 50,
	}, {
		prop: "ID",
		label: "系统编号",
		columnwidth: 80,
	},
	{
		prop: "CusName",
		label: "经销商名称",
		columnwidth: 260,
	},
	{
		prop: "Year",
		label: "年份",
		columnwidth: 80,
	},
	{
		prop: "InvClassName",
		label: "产品线",
		columnwidth: 100,
	},
	{
		prop: "YearQuota",
		label: "全年指标",
		columnwidth: 120,
	},
	{
		prop: "FirstQuarterQuota",
		label: "一季度指标",
		columnwidth: 130,
	},
	{
		prop: "SecondQuarterQuota",
		label: "二季度指标",
		columnwidth: 130,
	},
	{
		prop: "ThirdQuarterQuota",
		label: "三季度指标",
		columnwidth: 130,
	},
	{
		prop: "ForthQuarterQuota",
		label: "四季度指标",
		columnwidth: 130,
	},
	{
		prop: "JanQuota",
		label: "一月指标",
		columnwidth: 130,
	},
	{
		prop: "FebQuota",
		label: "二月指标",
		columnwidth: 130,
	},
	{
		prop: "MarQuota",
		label: "三月指标",
		columnwidth: 130,
	},
	{
		prop: "AprQuota",
		label: "四月指标",
		columnwidth: 130,
	},
	{
		prop: "MayQuota",
		label: "五月指标",
		columnwidth: 130,
	},
	{
		prop: "JunQuota",
		label: "六月指标",
		columnwidth: 130,
	},
	{
		prop: "JulQuota",
		label: "七月指标",
		columnwidth: 130,
	},
	{
		prop: "AugQuota",
		label: "八月指标",
		columnwidth: 130,
	},
	{
		prop: "SepQuota",
		label: "九月指标",
		columnwidth: 130,
	},
	{
		prop: "OctQuota",
		label: "十月指标",
		columnwidth: 130,
	},
	{
		prop: "NovQuota",
		label: "十一月指标",
		columnwidth: 130,
	},
	{
		prop: "DecQuota",
		label: "十二月指标",
		columnwidth: 130,
	},
	{
		prop: "ReviseTime",
		label: "修订日期",
		columnwidth: 120,
	},
	{
		prop: "CreatorName",
		label: "创建人",
		columnwidth: 130,
	},
	{
		prop: "CreateTime",
		label: "创建时间",
		columnwidth: 120,
	}
];
export default headerData;